module.exports = __webpack_public_path__ + "static/media/435GriffinStNW_2018-06-05_38.d7a179bb.jpg";